import React from 'react';
import { WorklogHoursSection as NewWorklogHoursSection } from '../NewWorklog';

const WorklogHoursSection = (props) => {
  return <NewWorklogHoursSection {...props} />;
};

export default WorklogHoursSection;
